import { Component, Input } from '@angular/core'

import { ScopeElementsConfig } from '../models'
import { isPreferenceActive } from '@app/shared/components/ui-components/scope-ui-table/table-column-preferences.type'

@Component({ selector: 'scope-components-row-header', templateUrl: './components-row-header.component.html' })
export class ComponentsRowHeaderComponent {
  @Input() level: number
  @Input() config: ScopeElementsConfig

  protected readonly isPreferenceActive = isPreferenceActive
}
